import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const price = {
  text: (theme: Theme) => css`
    color: ${theme.text.body};
  `,
  dark: (theme: Theme) => css`
    color: ${theme.text.body};
  `,
  darkBold: (theme: Theme) => css`
    color: ${theme.text.body};
    font-weight: ${typography.weightSemiBold};
  `,
  green: (theme: Theme) => css`
    color: ${theme.success.textBase};
    font-weight: ${typography.weightSemiBold};
  `,
  grey: (theme: Theme) => css`
    color: ${theme.text.emphasis};
  `,
  purple: (theme: Theme) => css`
    color: ${theme.highlight.textBase};
  `,
};

export const blur = css`
  filter: blur(3px);
  user-select: none;
`;

export const secondaryWeight = css`
  font-weight: ${typography.weightBase};
`;

export const unit = css`
  white-space: nowrap;
`;

export const bold = css`
  font-weight: ${typography.weightSemiBold};
`;
